// src\services\tokenStore.ts
const KEY = "qavach_teledoc_auth";


export type StoredAuth = {
  accessToken?: string;
  idToken?: string;
  user?: any;
};


export const tokenStore = {
  get(): StoredAuth {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "{}");
    } catch {
      return {};
    }
  },
  set(v: StoredAuth) {
    localStorage.setItem(KEY, JSON.stringify(v));
  },
  clear() {
    localStorage.removeItem(KEY);
  },
};





